import Authorizer from "../../components/Authorizer";
import IconLinkButton from "../../components/IconLinkButton";
import SalesTable from "../../tables/SalesTable";
import ViewContents from "../../components/ViewContents";
import ViewHeader from "../../components/ViewHeader";
import { PlusCircle } from "react-feather";
import { listSales } from "../../clients/finance";
import { usePersistentState } from "../../hooks/usePersistentState";

function Sales() {
  const [params, setParams] = usePersistentState(
    {
      skip: 0,
      limit: 100,
    },
    "Sales:params"
  );

  return (
    <>
      <ViewHeader
        breadcrumbs={["Sales"]}
        actions={
          <Authorizer role={["admin", "editor"]}>
            <IconLinkButton
              to="/sales/new"
              icon={PlusCircle}
              className="btn btn-success"
            >
              Create sale
            </IconLinkButton>
          </Authorizer>
        }
      />
      <ViewContents>
        <SalesTable
          params={params}
          onParamsChange={setParams}
          request={listSales}
          paginated={true}
        />
      </ViewContents>
    </>
  );
}

export default Sales;
